class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    const closeBtn = this.querySelector('#close-search-drawer');
    this.container = this.parentElement;

    const self = this;

    closeBtn.addEventListener('click', function () {
      self.close();
    });
  }

  close() {
    this.container.classList.add('closed');
    document.body.classList.remove('overflow-hidden');
  }

  open() {
    this.container.classList.remove('closed');
    document.body.classList.add('overflow-hidden');
  }
}

if (!customElements.get('search-drawer')) {
  customElements.define('search-drawer', SearchDrawer);
}

function openSearchDrawer() {
  const drawer = document.querySelector('search-drawer');
  drawer.open();
}
